import { api } from './client';
import type {
  AccountParty, AccountPartyCreateInput, AccountPartyRole, AccountPartyUpdateInput,
  Page, UUID, WriteResult,
} from './types';

export interface AccountPartiesListParams {
  account_id?: UUID; person_id?: UUID; role?: AccountPartyRole;
  include_deleted?: boolean; limit?: number; offset?: number;
  /** P41: a column key, '-' prefix to reverse (server-side). */
  sort?: string;
}
function qs(p: object): string {
  const u = new URLSearchParams();
  for (const [k, v] of Object.entries(p)) if (v !== undefined && v !== null && v !== '') u.set(k, String(v));
  return u.toString() ? `?${u}` : '';
}

async function writeWithMaker<T>(
  call: () => Promise<{ data: T; status: number; headers: Headers }>,
): Promise<WriteResult<T>> {
  const r = await call();
  return {
    entity: r.data,
    pending: r.headers.get('X-Change-Request-Status') === 'pending',
    changeRequestId: r.headers.get('X-Change-Request-Id'),
  };
}

export const accountPartiesApi = {
  list:    (p: AccountPartiesListParams = {}) => api.get<Page<AccountParty>>(`/account-parties${qs(p)}`),
  get:     (id: UUID)                          => api.get<AccountParty>(`/account-parties/${id}`),
  create:  (payload: AccountPartyCreateInput)  => writeWithMaker(() => api.postMeta<AccountParty>('/account-parties', payload)),
  update:  (id: UUID, p: AccountPartyUpdateInput) => writeWithMaker(() => api.patchMeta<AccountParty>(`/account-parties/${id}`, p)),
  delete:  (id: UUID)                          => writeWithMaker(() => api.deleteMeta<AccountParty>(`/account-parties/${id}`)),
  restore: (id: UUID)                          => writeWithMaker(() => api.postMeta<AccountParty>(`/account-parties/${id}/restore`)),
};
